export const getRemainingTime = (
  targetDate: Date
): { days: number; hours: number; minutes: number; seconds: number; ended: boolean } => {
  const now = new Date();
  const difference = targetDate.getTime() - now.getTime();

  if (difference <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, ended: true };
  }

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((difference % (1000 * 60)) / 1000);

  const ended = days === 0 && hours === 0 && minutes === 0 && seconds === 0;

  return { days, hours, minutes, seconds, ended };
};
